<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->




$( document ).ready(function() {

  $(".show-popup_").on('click', function(e) {
    setTimeout(function() {
      $("body").addClass('newsletter-show');
     }, 300);
    setTimeout(function() {
      $("body").addClass('show-newsletter-image');
     }, 500);
  });

  setTimeout(function(){
      // $("#map_inner a").css('color', '#fff !important');
      // $("#map_inner a").remove();
    }, 3000);
  $("#map").hover(function(){
    setTimeout(function(){
      // $("#map_inner a").remove();
    }, 100);
  });

  console.log(123123);

  document.addEventListener("DOMContentLoaded", function(){
      $(".snptwdgt-rtd__f1tr").hide();
      $(".snptwdgt-rtd__f1tr").css({
        "display": "none !important"
      });
      console.log('removed logo')
  });
  $(".snptwdgt-rtd__f1tr").hide();
  $(".snptwdgt-rtd__f1tr").addClass('asdasdas');
  $(".snptwdgt-rtd__f1tr").css({
    "display": "none !important"
  });
  console.log('removed logo')
  var x = setInterval(function() {
    if ($(".snptwdgt-rtd__f1tr").length == 1) 
    {
      
      $(".snptwdgt-rtd__f1tr").attr('style', "display: none !important;");
      $(".snptwdgt-rtd__f1tr").addClass('found')
      
    }
    
  }, 1000);
       


  

function MatchHeight() {

      jQuery('.custom-service-block .policies-content .policies-des').matchHeight();
      jQuery('.template-index .custom-service-block .halo-row .halo-item span.policies-text').matchHeight();
      
    
  }


  $(document).ready(function() {

    MatchHeight(); 

  });



})

